module.exports = __webpack_public_path__ + "static/media/sow-login-banner4.4d886184.png";